const actionTypes = {
  SAVE_MEMORY: "seneca/memories/SAVE_MEMORY",
  RECEIVE_MEMORIES: "seneca/memories/RECEIVE_MEMORIES",
  RECONCILE_MEMORIES: "seneca/memories/RECONCILE_MEMORIES"
};

export default actionTypes;
